<template>
  <helper-error-page>
    <template #description>
      <span>{{ $t('ist.error.page500Description') }}</span>
    </template>
  </helper-error-page>
</template>
